import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Typography from "@components/Typography";
import { getIconPath, getMarketPairDisplay } from "@core/utils/getCurrencyMeta";
import useStyles from "./styles";
import { Paper, Popover } from "@material-ui/core";
import clsx from "clsx";
import MarketSelectTab from "./MarketSelectTab";

const CurrencySelect = () => {
  const classes = useStyles();
  const { currencyName } = useParams();
  const { base, baseName, quoteName, baseUnit, quoteUnit } =
    getMarketPairDisplay(currencyName);
  const [state, setState] = useState({
    open: false,
    anchorEl: false,
  });

  const handleOpen = (event) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      anchorEl: event.target,
    }));
  };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      open: null,
      anchorEl: null,
    }));
  };

  return (
    <div>
      <div className={classes.currencySelect} onClick={handleOpen}>
        <div className={classes.currencyContainer}>
          <img
            src={getIconPath(base)}
            className={classes.currencyImage}
          />
          <div className={classes.currencyText}>
            <Typography isBold>{baseName}</Typography>
            /{" "}
            <Typography isBold>
              {" "}
              {quoteName}
            </Typography>
          </div>
          <div className={classes.currencyText}>
            <Typography color="secondary.tint40">
              ({baseUnit}/
            </Typography>
            <Typography color="secondary.tint40">
              {" "}
              {quoteUnit})
            </Typography>
          </div>
        </div>
        <div
          className={clsx(
            state.open ? "icon-x" : "icon-chevron-down",
            classes.icon
          )}
        />
      </div>
      {state.open && (
        <Popover
          open={state.open}
          anchorEl={state.anchorEl}
          onClose={handleClose}
          className={classes.popOverContainer}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <Paper className={classes.popOver} elevation={0}>
            <MarketSelectTab handleClose={handleClose} />
          </Paper>
        </Popover>
      )}
    </div>
  );
};

export default CurrencySelect;
